module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAAAXNSR0IArs4c6QAAAJZJREFUGBljZLh85yjD//9WDMQARsZjTAwMTEEMDIxXCasHqmFiDmYEK7z5TITh19fdDP8ZDLBqZGS4wMDG7cqgLvUGaAMQABkM/9mcGBgZTmFoYGQ8DZYDqQECiA0wVbff8jH8eL8V6CcbsBAj41EGDkEvBlXhTzAlqBpAoi9ecDO8/rKWgeE/I4MobxCDhMRXmGIQDQDtEiZVCnlnuAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav-pc/up.png
// module id = hB/Y
// module chunks = 4